import type React from 'react';

type SendOnEnterOptions = {
  onSend: () => void;
  /** When false, Enter falls through to the textarea default (newline); callers pass their own gate. */
  isEnabled: boolean;
};

/**
 * Shared onKeyDown for a message composer textarea: Enter sends, Shift+Enter inserts a newline.
 * The enabled gate is supplied by the caller so each app keeps its own send condition.
 */
export const createSendOnEnterHandler =
  ({ onSend, isEnabled }: SendOnEnterOptions) =>
  (e: React.KeyboardEvent): void => {
    if (e.key === 'Enter' && !e.shiftKey && isEnabled) {
      e.preventDefault();
      onSend();
    }
  };
